import type { IPlace } from "@bbj-types/address";
import { type Dispatch, useCallback, useMemo, useState } from "react";
import type { FiltersActions, TCandidateFilters } from "../../logics/types";

export const useCandidatePlaceFilter = (filters: TCandidateFilters, dispatch: Dispatch<FiltersActions>) => {
  const [innerPlaces, setInnerPlaces] = useState<IPlace[]>(filters.place ?? []);

  const badgeCount = useMemo(() => filters.place?.length ?? 0, [filters.place]);

  const onClose = useCallback(() => dispatch({ type: "place", payload: innerPlaces }), [innerPlaces]);
  const onOpen = useCallback(() => setInnerPlaces(filters.place ?? []), [filters.place]);

  return {
    innerPlaces,
    setInnerPlaces,
    badgeCount,
    onClose,
    onOpen,
  };
};
